//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import cx from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { VALIDATION_FAILED_STATE } from '@apis/catalog-validation/catalogValidationModel';
import { ConnectPanelActions } from '@catalog-ingestion/actions/connectPanelActions';
import { GoogleCatalogIngestionModalActions } from '@catalog-ingestion/actions/googleCatalogIngestionModalActions';
import { ICuralateStore } from '@models/AppState';
import styled from 'styled-components';
import { ReduxDispatch } from 'app/curalate.store';

function mapStateToProps(state: ICuralateStore) {
  return {
    ...state.catalogIngestionReducers.connectPanel,
    validationStatus: state.catalogIngestionReducers.googleCatalogIngestionModal.validationStatus,
  };
}

const mapDispatchToProps = (dispatch: ReduxDispatch) => {
  return {
    actions: {
      connectPanel: bindActionCreators(ConnectPanelActions, dispatch),
      modal: bindActionCreators(GoogleCatalogIngestionModalActions, dispatch),
    },
  };
};

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
export class CatalogUrlField extends React.Component<Props> {

  public catalogUrlInputClasses = cx({
    'cu-input-error': this.props.isUrlEmpty || VALIDATION_FAILED_STATE[this.props.validationStatus],
    'cu-form-control': true,
  });

  public onClickCatalogUrlField = () => {
    this.props.actions.connectPanel.setIsUrlEmpty(false);
  }

  public onChangeCatalogUrl = (event: React.ChangeEvent<HTMLInputElement>) => {
    const actions = this.props.actions.connectPanel;
    actions.changeCatalogUrl(event.target.value);
    if (this.props.catalogUrl) {
      actions.setIsUrlEmpty(false);
    }
  }

  public onChangeLoginName = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.actions.connectPanel.changeLoginName(event.target.value);
  }

  public onChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.actions.connectPanel.changePassword(event.target.value);
  }

  public render() {
    return (
      <div>
        <div className='cu-text-subsection cu-pb-1'>
          Catalog URL
        </div>
        <div className='cu-text-body cu-pb-2'>
          Enter your URL with one of the supported URL types: http, https, or ftp. If your URL
          requires a login to access, please enter your username and password below.
        </div>
        <InputSectionWrapper>
          <InputWrapper>
            <label className='cu-text-body cu-pb-1'>
              Catalog Url
            </label>
            <CatalogInput
              className={ this.catalogUrlInputClasses }
              onChange={ this.onChangeCatalogUrl }
              placeholder='Enter catalog URL'
              value={ this.props.catalogUrl }
              type='text'
            />
          </InputWrapper>
          <CredentialWrapper>
            <InputWrapper>
              <label className='cu-text-body cu-pb-1'>
                Login name (optional)
              </label>
              <input
                className='cu-form-control cu-w-100 cu-mr-3'
                onChange={ this.onChangeLoginName }
                placeholder='Enter login name'
                value={ this.props.loginName }
                type='text'
                autoComplete='new-password'
              />
            </InputWrapper>
            <InputWrapper>
              <label className='cu-text-body cu-pb-1'>
                Password (optional)
              </label>
              <input
                className='cu-form-control cu-w-100 cu-mr-3'
                onChange={ this.onChangePassword }
                placeholder='Enter password'
                value={ this.props.password }
                type='password'
                autoComplete='new-password'
              />
            </InputWrapper>
          </CredentialWrapper>
        </InputSectionWrapper>
      </div>
    );
  }
}

const InputSectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${({theme}) => theme.spacings['3']};
`;

const CredentialWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${({theme}) => theme.spacings['3']};
`;

const InputWrapper = styled.div`
  flex: auto;
  margin-right: ${({theme}) => theme.spacings['3']};
`;

const CatalogInput = styled.input`
  flex: auto;
  width: 100%;
  margin-right: ${({theme}) => theme.spacings['3']};
`;

export default connect(mapStateToProps, mapDispatchToProps)(CatalogUrlField);
